'use strict';
import React from 'react';
import flux from 'utils/flux';

var ShareModal = React.createClass({
    displayName: 'ShareModal',
    propTypes: {
        shareUrl: React.PropTypes.object
    },
    getInitialState() {
        return {
            copied: false
        };
    },
    onCopy() {
        this.setState({copied: true});
    },
    onFocus(e) {
        e.target.disabled || e.target.select();
    },
    renderSuccess() {
        if (this.state.copied) {
            return (
                <span className="copy__success">{flux.t('copied')}</span>
            );
        }
    },

    render() {
        let sharedURL = this.props.shareUrl || flux.t('share_wait');

        function unselectTextArea() {
            if (window.getSelection) {
                window.getSelection().removeAllRanges();
            }
            else if (document.selection) {
                document.selection.empty();
            }
        }

        let self = this;
        this.copyLinkToClipboard = function () {
            var textarea = document.getElementById("textarea");
            textarea.focus();
            textarea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text to clipboard was ' + msg);
                self.onCopy();
            } catch (err) {
                console.error('Unable to copy to clipboard', err);
            }
            unselectTextArea();
        }

        return (
            <div>
                <h4>{flux.t('copy-share-url')}</h4>

                <form>
                    <input id="textarea" type="text" readOnly="true" disabled={this.props.shareUrl ? false : true} value={sharedURL} onFocus={this.onFocus}/>
                </form>

                <button onClick={flux.getActions('modals').closeModals} className="btn btn-secondary">{flux.t('cancel')}</button>
                <button onClick={this.copyLinkToClipboard} className="btn btn-secondary">{flux.t('copy')}</button>
                {this.renderSuccess()}
            </div>
        );
    }
});

module.exports = ShareModal;



// WEBPACK FOOTER //
// ./app/components/modals/shareModal.jsx